import { SvgIcon } from '@mui/material';
import { motion } from 'motion/react';
import { forwardRef } from 'react';

import type { AnimatedIconProps, AnimeatableIconRef } from './types';
import { pathVariants } from './types';
import { useAnimatedIcon } from './useAnimatedIcon';

const CarIcon = forwardRef<AnimeatableIconRef, AnimatedIconProps>(
  ({ size = 28, strokeWidth = 2, titleAccess, color, fontSize }, ref) => {
    const controls = useAnimatedIcon(ref);

    return (
      <SvgIcon
        titleAccess={titleAccess}
        color={color}
        fontSize={fontSize}
        sx={fontSize ? undefined : { width: size, height: size }}
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <motion.path
            variants={pathVariants}
            initial="visible"
            animate={controls}
            custom={0}
            d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2"
          />
          <motion.circle
            variants={pathVariants}
            initial="visible"
            animate={controls}
            custom={1}
            cx="7"
            cy="17"
            r="2"
          />
          <motion.path
            variants={pathVariants}
            initial="visible"
            animate={controls}
            custom={2}
            d="M9 17h6"
          />
          <motion.circle
            variants={pathVariants}
            initial="visible"
            animate={controls}
            custom={3}
            cx="17"
            cy="17"
            r="2"
          />
        </svg>
      </SvgIcon>
    );
  }
);

CarIcon.displayName = 'CarIcon';

export { CarIcon };
